
import { Component, Prop, Vue, Provide, Emit } from 'vue-property-decorator'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import SliderValidComp from '../../../components/sliderValid/index.vue'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: {
    SliderValidComp
  }
})
export default class extends Vue {
  get PageStore() {
    return this.$store.$storeUser
  }
  get locale() {
    return this.$EnumLocaleLinks
  }
  get formOptions() {
    return {
      phone: true,
      password: this.password,
      btnText: '登录'
    }
  }
  visible = false
  password = false
  tabPane = [
    { key: 1, title: '手机验证码登录' },
    { key: 2, title: '手机密码登录' }
  ]
  activeKey = 1
  isClickBtn: boolean = false
  tabsChange(activeKey) {
    this.activeKey = activeKey
    if (lodash.eq(activeKey, '1')) {
      this.password = false
    } else {
      this.password = true
    }
  }
  tempModel: any
  tempCallback: any

  // 是否正在oauth
  isSubmitting = false

  closeHandler() {
    this.visible = false
  }

  confirmhandler() {
    this.closeHandler()
    this.onSubmit(this.tempModel)
  }

  @Bind
  @Debounce(500, { leading: true, trailing: false })
  async onValidLogin(model) {
    if (this.isSubmitting) return
    this.tempModel = model
    if (this.password) {
      this.isClickBtn = true
    } else {
      try {
        const resp = await this.PageStore.onValidAccountExist({
          device: model.device,
          verifyCode: model.verifyCode,
          verifyCodeType: 1
        })
        if (!resp) {
          this.visible = true
          return
        }
      } catch (error) {
        return
      }

      this.onSubmit(this.tempModel)
    }
  }

  async onValidSend(model, callback, closeLockCallback) {
    this.tempModel = model
    this.tempCallback = callback
    closeLockCallback()
    this.isClickBtn = true
  }
  async onSuccessHandler() {
    this.PageStore.onChangeLoginModalLoading(true)
    this.isClickBtn = false
    try {
      if (this.password) {
        await this.onSubmit(this.tempModel)
      } else {
        await this.onSendSms(this.tempModel, this.tempCallback)
      }
    } finally {
      this.PageStore.onChangeLoginModalLoading(false)
    }
  }
  async onSendSms(model, callback) {
    try {
      await this.PageStore.onLoginByPhone(Number(model.device))
      callback()
    } catch (error) {
      if (lodash.eq(error, false)) this.$msg(this.$EnumMessage.check_code_error)
    }
  }
  async onSubmit(model) {
    try {
      this.isSubmitting = true
      await this.$store.$storeUser.onLogin(
        {
          itcode: model.device,
          password: model.password,
          code: model.verifyCode
        },
        this.password ? 'phone_pwd' : 'sms_code'
      )
      // this.PageStore.onToggleVisible(false)
      this.$msg('登录成功，欢迎你桐学 🎉')
      setTimeout(() => {
        window.location.reload()
      }, 50)
    } catch (error) {
    } finally {
      this.isSubmitting = false
    }
  }
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
